import { Component, OnInit, ViewChild } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap';

import { CBMError, Column, DatatableButton, OsmVersion } from 'app/models';
import { OsmVersionStatusType } from 'app/models/enums';
import { OsmVersionService } from 'app/services';

@Component({
  selector: 'app-osm-version',
  templateUrl: './osm-version.component.html',
  styleUrls: ['./osm-version.component.scss']
})
export class OsmVersionComponent implements OnInit {
  @ViewChild('deleteOsmVersionDialog') deleteOsmVersionDialog: ModalDirective;
  @ViewChild('approveOsmVersionDialog') approveOsmVersionDialog: ModalDirective;

  public osmVersions: OsmVersion[];
  public osmVersionToDelete: OsmVersion;
  public osmVersionToApprove: OsmVersion;
  public errorMessages: CBMError[];
  public deleteOsmErrorMessages: CBMError[];
  public approveOsmErrorMessages: CBMError[];
  public columns: Column[] = [
    { property: 'id', label: 'OSMVERSION.TABLE.ID', type: 'string', flexGrow: 0.5 },
    { property: 'schemaName', label: 'OSMVERSION.TABLE.SCHEMANAME', type: 'string' },
    { property: 'status', label: 'OSMVERSION.TABLE.STATUS', type: 'string' },
    { property: 'version', label: 'OSMVERSION.TABLE.VERSION', type: 'string' },
    { property: 'importDate', label: 'OSMVERSION.TABLE.IMPORTDATE', type: 'date', flexGrow: 1.5 },
    { property: 'approveDate', label: 'OSMVERSION.TABLE.APPROVEDATE', type: 'date', flexGrow: 1.5 },
    { property: 'deleteDate', label: 'OSMVERSION.TABLE.DELETEDATE', type: 'date', flexGrow: 1.5 },
    { property: 'mutationUser', label: 'OSMVERSION.TABLE.MUTATIONUSER', type: 'string', flexGrow: 2.5 }
  ];
  public datatableButtons: DatatableButton[] = [
    {
      id: 'deleteOsmVersionBtn',
      icon: 'trash',
      action: this.prepareDeleteOsmVersion.bind(this),
      showIf: this.showDeleteOsmVersion.bind(this)
    },
    {
      id: 'approveOsmVersionBtn',
      icon: 'ok',
      action: this.prepareApproveOsmVersion.bind(this),
      showIf: OsmVersionComponent.showApproveOsmButton.bind(this)
    }
  ];

  private static showApproveOsmButton(osmVersion: OsmVersion): boolean {
    return osmVersion.status === OsmVersionStatusType.MATCHED;
  }

  constructor(public osmVersionService: OsmVersionService) {}

  ngOnInit() {
    this.getCurrentOsmVersion();
    this.getAllOsmVersions();
  }

  private getCurrentOsmVersion(): void {
    if (!this.osmVersionService.currentOsmVersion) {
      this.osmVersionService.getCurrentOsmVersion().subscribe(
        (currentOsmVersion: OsmVersion) => {
          this.osmVersionService.currentOsmVersion = currentOsmVersion;
        },
        (errors: CBMError[]) => {
          this.errorMessages = errors;
        }
      );
    }
  }

  private getAllOsmVersions(): void {
    this.osmVersionService.getOsmVersions().subscribe(
      osmVersions => {
        this.osmVersions = osmVersions;
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
      }
    );
  }

  private showDeleteOsmVersion(osmVersion: OsmVersion): boolean {
    return (
      osmVersion.status !== OsmVersionStatusType.DELETED &&
      this.osmVersionService.currentOsmVersion &&
      this.osmVersionService.currentOsmVersion.id !== osmVersion.id
    );
  }

  private prepareDeleteOsmVersion(osmVersion: OsmVersion): void {
    if (this.showDeleteOsmVersion(osmVersion)) {
      this.deleteOsmErrorMessages = [];
      this.osmVersionToDelete = osmVersion;
      this.deleteOsmVersionDialog.show();
    }
  }

  private prepareApproveOsmVersion(osmVersion: OsmVersion): void {
    if (OsmVersionComponent.showApproveOsmButton(osmVersion)) {
      this.approveOsmErrorMessages = [];
      this.osmVersionToApprove = osmVersion;
      this.approveOsmVersionDialog.show();
    }
  }

  public stopDeleteOsmVersion(): void {
    this.deleteOsmVersionDialog.hide();
  }

  public stopApproveOsmVersion(): void {
    this.approveOsmVersionDialog.hide();
  }

  public deleteOsmVersion(): void {
    this.deleteOsmErrorMessages = [];

    this.osmVersionService.deleteOsmVersion(this.osmVersionToDelete.id).subscribe(
      response => {
        console.log(response);
        this.getAllOsmVersions();
        this.deleteOsmVersionDialog.hide();
        this.osmVersionToDelete = null;
      },
      (errors: CBMError[]) => {
        this.deleteOsmErrorMessages = errors;
      }
    );
  }

  public approveOsmVersion(): void {
    this.approveOsmErrorMessages = [];
    if (this.osmVersionToApprove) {
      this.osmVersionService.approveOsmVersion(this.osmVersionToApprove.id).subscribe(
        () => {
          this.getAllOsmVersions();
          this.approveOsmVersionDialog.hide();
        },
        (errors: CBMError[]) => {
          this.approveOsmErrorMessages = errors;
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/osm-version/osm-version.component.ts